import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '../../../../../_metronic/helpers'
import { getDadosImportacao } from '../erros/core/_requests'

/** Importação da rota (`:id`), em cache pela chave: erros e detalhes dividem a requisição. */
export const useImportacao = () => {
  const { id } = useParams()
  const idImportacao = Number(id)

  const { data: importacao, isLoading } = useQuery(
    ['importacao', idImportacao],
    () => getDadosImportacao(idImportacao),
    { enabled: Boolean(idImportacao), refetchOnWindowFocus: false, onError: showError }
  )

  return { importacao, isLoading }
}
